export default {
    planned_burnout: {
        name: "Planned Burnout",
        url: "nwcg_lines_ops_planned/planned_burnout",
    },
    planned_dozer_line: {
        name: "Planned Dozer Line",
        url: "nwcg_lines_ops_planned/planned_dozer_line",
    },
    planned_hand_line: {
        name: "Planned Hand Line",
        url: "nwcg_lines_ops_planned/planned_hand_line",
    },
    planned_mixed_construction_line: {
        name: "Planned Mixed Construction Line",
        url: "nwcg_lines_ops_planned/planned_mixed_construction_line",
    },
    planned_plow_line: {
        name: "Planned Plow Line",
        url: "nwcg_lines_ops_planned/planned_plow_line",
    },
    "planned_road_as_line-1": {
        name: "Planned Road As Line-1",
        url: "nwcg_lines_ops_planned/planned_road_as_line-1",
    },
    planned_road_as_line: {
        name: "Planned Road As Line",
        url: "nwcg_lines_ops_planned/planned_road_as_line",
    },
}
